module.exports = __webpack_public_path__ + "img/nodata2.838ddb68.png";